module.exports = __webpack_public_path__ + "static/media/dz.29c9e0c5.svg";